<template>
  <v-card flat height="calc(100vh - 106px)" class="overflow-y pt-4 pl-4" :loading="loading">
    <v-container fluid>
      <v-row>
        <v-col>PŪRTRAK products and items are mapped to Shopify products by SKU.</v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="6" sm="3" lg="2">
          <v-select v-model="productView" :items="['Purtrak','Shopify']" label="Map from" outlined dense hide-details/>
        </v-col>
        <v-col cols="12" sm="9" class="text-caption">
          <template v-if="productView==='Purtrak'">
            Selecting a Shopify product for a PŪRTRAK product/item sets the PŪRTRAK SKU.
          </template>
          <template v-else>
            Selecting a PŪRTRAK product/item sets the Shopify product SKU.
          </template>
          <div>(Gift cards, shipping, and discounts are handled in the Orders tab.)</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card flat outlined>
            <v-data-table v-if="productView==='Purtrak'" class="no-sort"
                          calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                          :items="products"
                          :headers="[{text:'Type',value:'type',width:'10%'},
                                    {text:'Name',value:'name',width:'40%'},
                                    {text:'SKU',value:'sku',width:'10%'},
                                    {text:'Shopify product/variant',value:'shopify',width:'40%'}]">
              <template v-slot:item.sku="{item}">
                <template v-if="item.sku">{{item.sku}}</template>
                <v-chip v-else small color="warning">Undefined</v-chip>
              </template>
              <template v-slot:item.shopify="{item}">
                <v-select :items="shopifyProducts" hide-details class="text-body-2 pt-0 mt-0" v-model="item.shopifyId"
                          placeholder="No Shopify product with matching SKU" no-data-text="No Shopify products found"
                          @change="setProductSKU(item)" clearable @click:clear="clearProductSKU(item)">
                  <template v-slot:prepend-item v-if="!item.shopifyId">
                    <div class="pa-4 grey lighten-3 text-body-2 cursor-pointer"
                        @click="product={...item,addSKU:item.sku==='',parent:topLevelShopify[0] ? topLevelShopify[0].value : [],addVariant:false};showAddToShopify=true">
                      Add product to Shopify
                    </div>
                  </template>
                  <template v-slot:item="{item}">
                    <v-list-item-content class="text-body-2" :class="{'pl-4':item.indent}">
                      {{item.text}}
                      <v-list-item-subtitle v-if="item.disabled" class="text-caption">Shopify product missing SKU</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="text-caption">{{item.sku}}</v-list-item-action>
                  </template>
                </v-select>
              </template>
            </v-data-table>
            <v-data-table v-else class="no-sort"
                          calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                          :items="shopifyProducts"
                          :headers="[{text:'Product',value:'name',width:'40%'},
                                    {text:'SKU',value:'sku',width:'10%'},
                                    {text:'PURTRAK product/item (with a SKU)',value:'pt',width:'50%'}
                                    ]">
              <template v-slot:item.name="{item}">
                <span :class="{'ml-6':item.indent}">{{item.header || item.text}}</span>
              </template>
              <template v-slot:item.sku="{item}">
                <template v-if="item.sku">
                  {{item.sku}}
                </template>
                <v-chip v-else-if="!item.header" small color="warning">Undefined</v-chip>
                <div v-if="item.duplicateSKU" class="warning--text text-caption">DUPLICATE</div>
              </template>
              <template v-slot:item.pt="{item}">
                <v-select v-if="!item.header" :items="productsWithSKU" item-text="name" item-value="sku" hide-details class="text-body-2 pt-0 mt-0" v-model="item.sku"
                          placeholder="No PURTRAK product with matching SKU"
                          @change="setShopifySKU(item)" clearable @click:clear="setShopifySKU(item, true)">
                  <template v-slot:item="{item}">
                    <v-list-item-content class="text-body-2">
                      {{item.name}}
                      <v-list-item-subtitle v-if="item.sku===''" class="text-caption">Missing SKU</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="text-caption">{{item.sku}}</v-list-item-action>
                  </template>
                </v-select>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="showAddToShopify" persistent max-width="500">
      <v-card>
        <v-card-title>Add to Shopify</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-col class="text-body-1">Adding <strong>{{product.name}}</strong></v-col>
            </v-row>
            <v-row v-if="product.addSKU">
              <v-col cols="8" md="6"><v-text-field v-model="product.sku" label="SKU" outlined dense :error-messages="product.sku ? '' : 'Required'"/></v-col>
            </v-row>
            <v-row align="center" dense v-if="topLevelShopify.length">
              <v-col cols="8" md="4"><v-checkbox v-model="product.addVariant" label="Add as variant"/></v-col>
              <v-col cols="12" md="8"><v-select outlined dense hide-details :items="topLevelShopify" :disabled="!product.addVariant" v-model="product.parent"></v-select></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="primary" plain @click="showAddToShopify=false">Cancel</v-btn>
          <v-btn color="primary" @click="addToShopify" :disabled="!product.sku" :loading="loading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
export default {
  name: 'AppsShopifyProducts',
  props: {
    shopify: {type:Object, required:false}
  },
  data() {
    return {
      productView: 'Purtrak',
      products: [],
      shopifyProducts: [],
      topLevelShopify: [],
      product: {},
      showAddToShopify: false,
      loading: false
    }
  },
  computed: {
    productsWithSKU() {
      return this.products.filter(product => product.sku);
    }
  },
  async created() {
    this.loading = true;
    const shopifyResults = await this.$apiCall(`query AppsShopify {
                                                  shopify {
                                                    products {id, allowsVariants, productName,variants {id,variantName,sku,duplicateSKU}}
                                                  }
                                                }`,
                                              {}, false, 'shopify');
    if (!shopifyResults.error)
      this.shopify.products = shopifyResults.data.shopify.products;

//    const products = [];
    const bundles = [];
//    const items = [];
    const data = await Promise.all([
      this.$store.dispatch('products'),
      this.$store.dispatch('items'),
//      this.$lazyListLoad(products, 'products2', 'id,name,sku', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(bundles, 'bundles2', 'id,name,sku', 100, [{field:'active', comparator:'eq', value:'true'}]),
//      this.$lazyListLoad(items, 'items2', 'id,name,sku', 100, [{field:'active', comparator:'eq', value:'true'},{field:'sold',comparator:'eq',value:'true'},{field:'lotTracking',comparator:'eq',value:'false'}])
    ]);
    this.products = [...data[0].filter(product => product.active).map(product => ({...product,type:'Product'})),
                      ...data[1].filter(item => item.active).map(item => ({...item,type:'Item'})),
                      ...bundles.map(item => ({...item,type:'Bundle'}))
                    ];
    this.buildShopifyProducts();
    this.loading = false;
  },
  methods: {
    buildShopifyProducts() {
      // Build flat array of Shopify products for v-select and top level products only
      this.shopifyProducts = [];
      this.topLevelShopify = [];
      for (const product of this.shopify.products) {
        if (product.allowsVariants)
          this.topLevelShopify.push({text:product.productName,value:product.id});
        if (product.variants.length === 1) {
          const sku = product.variants[0].sku;
          this.shopifyProducts.push({text:product.productName,sku,duplicateSKU:product.variants[0].duplicateSKU,disabled:!sku,value:product.variants[0].id});
        }
        else {
          this.shopifyProducts.push({header:product.productName});
          for (const variant of product.variants) {
            const sku = variant.sku;
            this.shopifyProducts.push({text:variant.variantName,sku,duplicateSKU:variant.duplicateSKU,disabled:!sku,value:variant.id,indent:true});
          }
        }
      }

      // Set PT products to reference Shopify product
      for (const product of this.products) {
        const id = this.findShopifyProductId(product.sku);
        this.$set(product, 'shopifyId', id);
      }
    },
    findShopifyProductId(sku) {
      if (!sku)
        return null;
      for (const sProduct of this.shopify.products) {
        const variant = sProduct.variants.find(variant => variant.sku === sku);
        if (variant)
          return variant.id;
      }
      return null;
    },
    async setProductSKU(product) {
      let sku;
      for (const sProduct of this.shopify.products) {
        const variant = sProduct.variants.find(variant => variant.id === product.shopifyId);
        if (variant) {
          sku = variant.sku;
          break;
        }
      }
      if (!sku)
        product.shopifyId = null;
      else {
        const results = await this.$apiCall(`mutation AppsShopifyProducts($id: ID!, $sku:String!, $isProduct:Boolean!, $isItem:Boolean!, $isBundle:Boolean!) {
                                              productSetSKU(id:$id,sku:$sku) @include(if:$isProduct) {sku}
                                              itemSetSKU(id:$id,sku:$sku) @include(if:$isItem) {sku}
                                              bundleSetSKU(id:$id,sku:$sku) @include(if:$isBundle) {sku}
                                            }`,
                                            {id:product.id,sku,
                                             isProduct:product.type==='Product',
                                             isItem:product.type==='Item',
                                             isBundle:product.type==='Bundle'});
        if (!results.error) {
          if (product.type === 'Product')
            product.sku = results.data.productSetSKU.sku;
          else if (product.type === 'Item')
            product.sku = results.data.itemSetSKU.sku;
          else if (product.type === 'Bundle')
            product.sku = results.data.bundleSetSKU.sku;
        }
        else
          product.shopifyId = this.findShopifyProductId(product.sku);
      }
    },
    async clearProductSKU(product) {
      const results = await this.$apiCall(`mutation AppsShopifyProducts($id: ID!, $isProduct:Boolean!, $isItem:Boolean!, $isBundle:Boolean!) {
                                            productSetSKU(id:$id,sku:"") @include(if:$isProduct) {sku}
                                            itemSetSKU(id:$id,sku:"") @include(if:$isItem) {sku}
                                            bundleSetSKU(id:$id,sku:"") @include(if:$isBundle) {sku}
                                          }`,
                                            {id:product.id,
                                             isProduct:product.type==='Product',
                                             isItem:product.type==='Item',
                                             isBundle:product.type==='Bundle'});
      if (!results.error) {
        if (product.type === 'Product')
          product.sku = results.data.productSetSKU.sku;
        else if (product.type === 'Item')
          product.sku = results.data.itemSetSKU.sku;
        else if (product.type === 'Bundle')
          product.sku = results.data.bundleSetSKU.sku;
        product.shopifyId = null;
      }
    },
    async setShopifySKU(product, clear=false) {
      if (product.sku == null)
        return;
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsShopifyProducts($id: String!, $sku:String!) {
                                            shopifySetVariantSKU(id:$id,sku:$sku)
                                          }`,
                                          {id:product.value,sku:clear ? '' : product.sku}, false, 'shopify');
      this.loading = false;
      if (!results.error)
        product.sku = results.data.shopifySetVariantSKU;
    },
    async addToShopify() {
      this.loading = true;
      const product = this.products.find(p => p.id === this.product.id);

      if (this.product.addSKU) {


        const results = await this.$apiCall(`mutation AppsShopifyProducts($id: ID!, $sku:String!, $isProduct:Boolean!, $isItem:Boolean!, $isBundle:Boolean!) {
                                              productSetSKU(id:$id,sku:$sku) @include(if:$isProduct) {sku}
                                              itemSetSKU(id:$id,sku:$sku) @include(if:$isItem) {sku}
                                              bundleSetSKU(id:$id,sku:$sku) @include(if:$isBundle) {sku}
                                            }`,
                                            {id:this.product.id,sku:this.product.sku,
                                             isProduct:this.product.type==='Product',
                                             isItem:this.product.type==='Item',
                                             isBundle:this.product.type==='Bundle'});
        if (results.error) {
          this.loading = false;
          return;
        }
        if (product.type === 'Product')
          this.product.sku = results.data.productSetSKU.sku;
        else if (product.type === 'Item')
          this.product.sku = results.data.itemSetSKU.sku;
        else if (product.type === 'Bundle')
          this.product.sku = results.data.bundleSetSKU.sku;
        product.shopifyId = null;
        product.sku = this.product.sku;
      }

      if (this.product.sku) {
        const results = await this.$apiCall(`mutation AppsShopifyProducts($id: ID!, $parent:String) {
                                              shopifyAddProduct(id:$id,parent:$parent) {
                                                id,productName,allowsVariants,variants {id,variantName,sku,duplicateSKU}
                                              }
                                            }`,
                                            {id:this.product.id, parent:this.product.addVariant?this.product.parent:null}, false, 'shopify');
        if (!results.error) {
          this.shopify.products = results.data.shopifyAddProduct;
          this.buildShopifyProducts();
          product.shopifyId = this.findShopifyProductId(this.product.sku);
          this.showAddToShopify = false;
          this.$store.commit('setError', {type:'success',message:`${this.product.name} added to Shopify. You should check all settings for the product on Shopify.`});
        }
      }
      this.loading = false;
    }
  }
}
</script>